// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import dogWoman from './images/woman.svg'
import './styles.scss'

export class Section6 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section six' style={{colorScheme: this.props.colorMode === 'dark' ? 'dark' : 'light'}}>
      <div className="wrapper">
        <h2>D'où viennent la plupart des chiens?</h2>
        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                <p>
                  Un peu plus de 5% de la population sont officiellement propriétaires d'un chien. Cela signifie qu'une personne sur 20 en Suisse possède au moins un chien. Il est frappant de constater que près de deux tiers des propriétaires sont des femmes. Le sexe féminin est également majoritaire chez les animaux.
                </p>
                <p>
                  Si l'on devait décrire une détentrice typique en Suisse, elle ressemblerait donc à ceci: une femme habitant à Genève et possédant une chienne de la race chihuahua, nommée «Luna».
                </p>
                <img src={dogWoman} alt='woman' />
                <p>
                  Cette chienne aurait été importée d'Allemagne, car la demande en Suisse est bien plus importante que l'offre issue de l'élevage local. Au cours des sept dernières années, un peu plus de 214’000 animaux ont été achetés à l'étranger, la plupart chez nos voisins, mais aussi beaucoup en Europe de l'Est.
                </p>
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/dcQ8J/1/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  }
}
